import React, { Fragment } from "react"
import './blog.scss'

import { Link } from 'react-router-dom'
import { AllPosts } from '../../queries/blog'
import Back from '../../components/backButton/backButton'
import dayjs from 'dayjs'
import Navbar from '../../components/newNavbar/navbar'
import Footer from '../../components/newFooter/footer'
// import newButton from '../../components/button/button'
import Loading from '../../components/loading/loading'
// import ButtonText from '../../components/buttonText/buttonText'
import { Query } from 'react-apollo'
import Banner from '../../assets/banner-blog-oito.jpg'


export default class BlogList extends React.Component {

    render() {
        return (
            <Fragment>
                <Navbar />
                <div className="col-xs-12" style={{ marginLeft: "0", paddingLeft: "0" }}>
                    <img src={Banner} alt='Blog da Oito' className="bannerblog" />
                <div className="blog8">
                    {/* <h1>Blog</h1> */}

                    <div className="cards row center-xs" style={{flexWrap: 'wrap', justifyContent: 'center'}}>
                        <Query query={AllPosts}>
                            {res => {
                                console.log('console', res)
                                if (res.loading) return <Loading />
                                if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                                
                                if (res.data.allPosts) {
                                    if (res.data.allPosts.length > 0) {
                                        return res.data.allPosts.map((post, i) => (
                                                <div className='card col-xs-12' style={{maxWidth: '350px', marginBottom: 20}} key={i}>
                                                    <div className="card__img" style={{ backgroundImage: `url(${post.thumbnail})`}}></div>
                                                    <Link to={'/post/' + post.id} className="card_link">
                                                        <div className="card__img--hover" style={{ backgroundImage: `url(${post.thumbnail})`}}></div>
                                                    </Link>
                                                    <div className="card__info">
                                                        <span className="card__category">{post.categoria}</span>
                                                        <h3 className="card__title">{post.title}</h3>
                                                        <span className="card__date">{dayjs(post.updated).format("DD/MM/YYYY")}</span>
                                                    </div>
                                                </div>
                                        ))
                                    } else {
                                        return <p>nenhum post</p>
                                    }
                                } else {
                                    return <p>erro</p>
                                }
                            }}
                        </Query>
                    </div>
                </div>
                <Back />
                <div style={{ height: "20px" }} />
                <Footer />
                </div>
                
            </Fragment>
        )
    }
}

